import * as React from 'react';
import { ValidatorState, NameValidationService, Validator } from '../../../services/nameValidation';
import { LogManager } from '../../../utils/LogManager';
import { CheckMarkIcon, CrossMarkIcon } from '../Icons';

const logManager = new LogManager('RequirementManager');

export class NameRequirementManager {
    private validators: Validator[] | null;
    private validatorService: NameValidationService;
    private enabled: boolean;

    constructor() {
        this.validators = null;

        this.getRequirements = this.getRequirements.bind(this);
        this.requirementsAreMet = this.requirementsAreMet.bind(this);
        this.enabled = false;
    }

    public getRequirements(input: string): JSX.Element | null {
        if (!this.validators) {
            logManager.error('RequirementManager: Validators not set.');
            return null;
        }
        if (input) {
            this.enabled = true;
        }
        this.validatorService = new NameValidationService(this.validators, input);
        const validatorsList = this.validators.map((validator) => {
            let liClass = '';
            if (this.enabled) {
                validator.validate(input);
                switch (validator.getState()) {
                    case ValidatorState.Fail:
                        liClass = 'negative';
                        break;
                    case ValidatorState.Pass:
                        liClass = 'positive';
                        break;
                    default:
                    case ValidatorState.InactivePass:
                    case ValidatorState.Inactive:
                        liClass = '';
                        break;
                }
            }
            return (
                <li key={validator.getKey()} className={liClass}>
                    {
                        validator.getState() === ValidatorState.Fail ?
                            <CrossMarkIcon width="10px" style={{ marginRight: 12 }} /> :
                            <CheckMarkIcon width="12px" />
                    }
                    {validator.getDescription()}
                </li>
            );
        });
        return (
            <ul className="requirements">
                {validatorsList}
            </ul>
        );
    }

    public requirementsAreMet() {
        return this.validatorService ? this.validatorService.isValid() : false;
    }

    public setValidators(validators: Validator[]): void {
        this.validators = validators;
    }

    public setEnabled(enabled: boolean) {
        this.enabled = enabled;
    }
}



// WEBPACK FOOTER //
// ./src/webportal/components/common/requirementManagers/NameRequirementManager.tsx